<div class="fixed top-5 right-5 space-y-3 z-[1000]">
  <div
    *ngFor="let notification of notificationService.notifications$ | async"
    [ngClass]="{
      'bg-green-500 text-white': notification.type === 'success',
      'bg-red-500 text-white': notification.type === 'error',
      'bg-yellow-500 text-black': notification.type === 'warning',
      'bg-blue-500 text-white': notification.type === 'info'
    }"
    class="p-4 rounded-lg shadow-lg flex items-center justify-between w-80"
  >
    <span class="text-white">{{ notification.message }}</span>
    <button class="ml-4 text-white" (click)="notificationService.hide(notification.id)">✖</button>
  </div>
</div>
